import { render, staticRenderFns } from "./ERPCSettingsAdvanced.vue?vue&type=template&id=b7be970a"
import script from "./ERPCSettingsAdvanced.vue?vue&type=script&lang=js"
export * from "./ERPCSettingsAdvanced.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports